var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6256",
    "data-name": "Group 6256",
    transform: "translate(-1082 -742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5677",
    "data-name": "Group 5677",
    transform: "translate(-471 153)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_877",
    "data-name": "Ellipse 877",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1553 589)",
    fill: "#d1efea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5821",
    "data-name": "Group 5821",
    transform: "translate(1096 756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29183",
    "data-name": "Path 29183",
    d: "M2,7H19.1",
    transform: "translate(0 -0.5)",
    fill: "none",
    stroke: "#25a992",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29184",
    "data-name": "Path 29184",
    d: "M16.2,2,13.5,6.5",
    transform: "translate(-1.15)",
    fill: "none",
    stroke: "#25a992",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29185",
    "data-name": "Path 29185",
    d: "M9.2,2,6.5,6.5",
    transform: "translate(-0.45)",
    fill: "none",
    stroke: "#25a992",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29186",
    "data-name": "Path 29186",
    d: "M10.55,19.1c-4.031,0-6.046,0-7.3-1.252S2,14.58,2,10.55,2,4.5,3.252,3.252,6.52,2,10.55,2s6.046,0,7.3,1.252S19.1,6.519,19.1,10.55",
    transform: "translate(0)",
    fill: "none",
    stroke: "#25a992",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29187",
    "data-name": "Path 29187",
    d: "M14,17.6h7.2m-3.6,3.6V14",
    transform: "translate(-1.2 -1.2)",
    fill: "none",
    stroke: "#25a992",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSelection);
export default __webpack_public_path__ + "static/media/serviceSelection.a3db52c6726c35897e471a7a258fa1c8.svg";
export { ForwardRef as ReactComponent };